import React, { useState, useEffect  } from 'react'
import axios from 'axios';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
function Screens() {
const [posts, setPosts] = useState([]);
const [loading, setLoading] = useState(false);
let api = 'https://tallysolutions-uae.com/tallyprime/api/wp-json/wp/v2/screens?per_page=10';
useEffect(() => {
setLoading(true)
axios.get(api)
.then(res => {
//console.log(res)
setPosts(res.data)
setLoading(false)
})
}, [setPosts])
return (
<React.StrictMode>
   <section className="bg-gray pb-2 pt-0">
    
      {
      loading && 
      <section className="bg-white pt-5"><img src="https://tallysolutions-uae.com/tallyprime//assets/img/loading.gif" alt="loading" className="mx-auto d-block mt-5 pt-5" width="20" /></section>
      }
      {!loading &&
      <>
      <Carousel>
         {posts.map((post,i) => (
         <div>
            <img src={post.acf.screen} alt={post.title.rendered} className="d-blok w-100"/>
         </div>
         ))}
      </Carousel>
      </>
      }
   </section>
</React.StrictMode>
)
}
export default Screens;